import { DbRef } from '@caresend/types';
import { fetchWithRelationships } from '@caresend/utils';
import { usePortalStore } from '../index.js';
import '../../../../../../database/algoliaConfig/indices.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import { getFetchWithRelationshipsCallbacks } from '../relationships.js';
import 'firebase/auth';
import '../../../../../../database/firebaseConfig/cloudFunctions.js';
import '../../../../../../database/firebaseConfig/init.js';
import '../../../../../../database/firebaseConfig/methods.js';
import '../../../../../ui/Icon.vue.js';
import '../../../../../../functions/configuration/icons.js';
import 'mobile-device-detect';
import '../../../../../../functions/tracking/index.js';
import '../../../../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';

const getDraftWaypointDepsRelationships = () => {
    const bookingRelationships = {
        patientID: true,
    };
    const ordersRelationships = {
        prescriberID: true,
        bookings: bookingRelationships,
    };
    const proceduresRelationships = {
        bookingID: bookingRelationships,
        orderID: ordersRelationships,
        placeAccounts: true,
        supplyItems: true,
    };
    const relationships = {
        procedures: proceduresRelationships,
        supplyTransfers: {
            shipmentIDs: true,
        },
        waypointID: {
            waypointActions: {
                shipments: true,
            },
            placeID: true,
        },
    };
    return relationships;
};
const bindDraftWaypointDependencies = ({ id }) => fetchWithRelationships(DbRef.DRAFT_WAYPOINTS, id, getDraftWaypointDepsRelationships(), {
    batchingContextID: 'itinerary/searchResults',
    bind: true,
    writers: getFetchWithRelationshipsCallbacks(),
});
/**
 * For all draft waypoints that are not in the itinerary,
 * remove the waypoint preview and its related waypoint actions
 * from the store. Used to clear search result previews.
 */
const resetPreviews = () => {
    const portalStore = usePortalStore();
    const itineraryDraftWaypoints = portalStore.itinerary.getters.draftWaypointIDs();
    portalStore.draftWaypoints.forEach((dw) => {
        var _a;
        if (itineraryDraftWaypoints[dw.id])
            return;
        const preview = (_a = portalStore.draftWaypoints.get(dw.id)) === null || _a === void 0 ? void 0 : _a.computed.existingPreview;
        if (preview) {
            portalStore.waypoints.unset(preview.waypoint.id);
            preview.waypointActions.forEach((wpa) => {
                if (!wpa)
                    return;
                portalStore.waypointActions.unset(wpa.id);
            });
            portalStore.draftWaypoints.unset(dw.id);
        }
    });
};

export { bindDraftWaypointDependencies, resetPreviews };
